export default function reactionLeft(x: number): number {
	if (x < 200) return x
	else if (x > window.innerWidth - 200) return x - 400
	else return x - 200
}
